import React from 'react';
import '../styles/mpd.css';

export default function Founders() {
  return (
    <div className="mpd-container">
      <div className="mpd-content">
        <h1 className="mpd-title">Founders Program</h1>

        <div className="mpd-card mpd-fade-in">
          <h2 className="mpd-subtitle">Become a Founder Customer</h2>
          <p className="mpd-text">
            Join our exclusive Founders program and help shape the future of MyPeopleDatabase while
            enjoying premium benefits.
          </p>
        </div>

        <div className="mpd-card mpd-fade-in" style={{ width: '100%' }}>
          <h2 className="mpd-subtitle">Founder Benefits</h2>

          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
              gap: 'var(--mpd-spacing-md)',
              marginTop: 'var(--mpd-spacing-lg)',
            }}
          >
            <div
              style={{
                background: 'var(--mpd-bg-darker)',
                borderRadius: 'var(--mpd-radius-md)',
                padding: 'var(--mpd-spacing-md)',
                border: '1px solid var(--mpd-border-light)',
              }}
            >
              <h3
                style={{
                  color: 'var(--mpd-accent-primary)',
                  fontSize: '1.2rem',
                  marginBottom: 'var(--mpd-spacing-xs)',
                }}
              >
                Early Access
              </h3>
              <p className="mpd-text" style={{ margin: 0 }}>
                Be the first to experience new features and upgrades before they're available to the
                general public.
              </p>
            </div>

            <div
              style={{
                background: 'var(--mpd-bg-darker)',
                borderRadius: 'var(--mpd-radius-md)',
                padding: 'var(--mpd-spacing-md)',
                border: '1px solid var(--mpd-border-light)',
              }}
            >
              <h3
                style={{
                  color: 'var(--mpd-accent-primary)',
                  fontSize: '1.2rem',
                  marginBottom: 'var(--mpd-spacing-xs)',
                }}
              >
                Lifetime Discount
              </h3>
              <p className="mpd-text" style={{ margin: 0 }}>
                Enjoy a significant lifetime discount on all subscriptions and future premium
                features.
              </p>
            </div>

            <div
              style={{
                background: 'var(--mpd-bg-darker)',
                borderRadius: 'var(--mpd-radius-md)',
                padding: 'var(--mpd-spacing-md)',
                border: '1px solid var(--mpd-border-light)',
              }}
            >
              <h3
                style={{
                  color: 'var(--mpd-accent-primary)',
                  fontSize: '1.2rem',
                  marginBottom: 'var(--mpd-spacing-xs)',
                }}
              >
                Direct Input
              </h3>
              <p className="mpd-text" style={{ margin: 0 }}>
                Shape the product roadmap with direct access to our development team and regular
                feedback sessions.
              </p>
            </div>

            {/*<div style={{ 
              background: 'var(--mpd-bg-darker)', 
              borderRadius: 'var(--mpd-radius-md)',
              padding: 'var(--mpd-spacing-md)',
              border: '1px solid var(--mpd-border-light)'
            }}>
              <h3 style={{ 
                color: 'var(--mpd-accent-primary)', 
                fontSize: '1.2rem',
                marginBottom: 'var(--mpd-spacing-xs)'
              }}>Priority Support</h3>
              <p className="mpd-text" style={{ margin: 0 }}>
                Receive dedicated, priority support from our technical team whenever you need assistance.
              </p>
            </div>*/}

            <div
              style={{
                background: 'var(--mpd-bg-darker)',
                borderRadius: 'var(--mpd-radius-md)',
                padding: 'var(--mpd-spacing-md)',
                border: '1px solid var(--mpd-border-light)',
              }}
            >
              <h3
                style={{
                  color: 'var(--mpd-accent-primary)',
                  fontSize: '1.2rem',
                  marginBottom: 'var(--mpd-spacing-xs)',
                }}
              >
                Exclusive Community
              </h3>
              <p className="mpd-text" style={{ margin: 0 }}>
                Connect with other Founder customers in an exclusive community to share ideas and
                best practices.
              </p>
            </div>
          </div>
        </div>

        <div className="mpd-card mpd-fade-in">
          <h2 className="mpd-subtitle">How to Join</h2>
          <p className="mpd-text">
            Our Founders program is available by invitation only during this limited enrollment
            period. Contact us at{' '}
            <a
              href="mailto:founders@mypeopledatabase.com"
              style={{
                color: 'var(--mpd-accent-secondary)',
                textDecoration: 'none',
                fontWeight: 'bold',
              }}
            >
              founders@mypeopledatabase.com
            </a>{' '}
            to express your interest and learn about the enrollment process.
          </p>
        </div>

        <div
          className="mpd-card mpd-fade-in"
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            background: 'var(--mpd-gradient-accent)',
            padding: 'var(--mpd-spacing-xl) var(--mpd-spacing-lg)',
          }}
        >
          <h2 className="mpd-subtitle" style={{ color: 'white' }}>
            Ready to become a Founder?
          </h2>
          <p className="mpd-text" style={{ color: 'white', opacity: 0.9 }}>
            Take the first step towards a privileged partnership with MyPeopleDatabase.
          </p>
          <a
            href="mailto:support@mypeopledatabase.com"
            className="mpd-button mpd-button-success"
            style={{ marginTop: 'var(--mpd-spacing-md)', textDecoration: 'none' }}
          >
            Email Us for Invitation
          </a>
        </div>
      </div>
    </div>
  );
}
